// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__rkrM5","productName":"Table_productName__1Je9X"};